import { DEFAULT_AMPLITUDE_OPTIONS, RulaAmplitudeAdapterOptions } from '@pathccm/browser-analytics/amplitude'
import { ProductArea, UserType } from '@pathccm/common-analytics/events'
import AmplitudePlugin from '../amplitude-plugin'

export const AMPLITUDE_OPTIONS: RulaAmplitudeAdapterOptions = {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  apiKey: process.env.GATSBY_AMPLITUDE_API_KEY!,
  productArea: ProductArea.MARKETING_SITE,
  userType: UserType.PATIENT,
  plugins: [new AmplitudePlugin()],
  amplitudeOptions: {
    ...DEFAULT_AMPLITUDE_OPTIONS,
    autocapture: {
      attribution: true,
      sessions: true,
      // Deemed too noisy / less valuable to product for now
      pageViews: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false
    }
  }
}
